export const TYPE = { MAIN: 'main', CONTEXT: 'context' };
// Beware! Required field is check if the participant need to answer
// For MAIN question, we use excludeFromMarking -> as a flag to remove from
// the calculation process, and unrestrict user from complete answering it
// -------------------------------------------------------------------------
// For context question, we use required field -> as it applies, required to
// to answer or not
// -------------------------------------------------------------------------
// PLEASE FIX THIS IF YOU GOT TIME!
export const QUESTION_TYPES = {
  main: {
    buttonLabelid: 'questionscontainer.addquestion',
    types: [
      { id: 'OneOf', text: 'Single Choice' },
      { id: 'MultipleChoice', text: 'Multiple Choice' },
      { id: 'ArbitraryString', text: 'Free Text' },
    ],
    requiredField: { prop: 'excludeFromMarking', defaultVal: false, requiredReverse: true },
  },
  context: {
    buttonLabelid: 'questionscontainer.addcontextquestion',
    types: [
      { id: 'freeText', text: 'Free Text' },
      { id: 'MultipleChoice', text: 'Multiple Choice' },
      { id: 'single', text: 'Single Choice' },
    ],
    requiredField: { prop: 'required', defaultVal: false, requiredReverse: false },
  },
};
export const REQUIRE_OPTIONS = ['OneOf', 'single', 'MultipleChoice'];
export const REQUIRE_PLACEHOLDER = ['ArbitraryString', 'freeText'];
